<app-topnav></app-topnav>


<!-- HEADER -->
<app-header-secondary-g   [pageTitle]="'offresemploi.title' | translate" 
[pageDescription]="'offresemploi.description' | translate"
[imageURL]="'assets/img/header/headerg-blob-emploi.png'"></app-header-secondary-g>
<!-- end HEADER -->

<section  id="section-offresemploi">

<div class="container" *ngIf="nbOffresEmploi==0">

    <p> {{ 'offresemploi.aucune' | translate }}</p>

</div>

<div class="container" *ngIf="nbOffresEmploi!=0">

        <div class="" *ngFor="let OffreEmploi of listeOffresEmploi">

            <div *ngIf="currentLang ==='fr'">
                <div><a [routerLink]="['/offresemploi', OffreEmploi.id]">{{OffreEmploi.titreFR}}</a></div>
                <div>{{OffreEmploi.texteFR}}</div>
            </div>
            <div *ngIf="currentLang ==='en'">
                <div><a [routerLink]="['/offresemploi', OffreEmploi.id]">{{OffreEmploi.titreEN}}</a></div>
                <div>{{OffreEmploi.texteEN}}</div>
            </div>

        </div>
    
    </div>
    
</section>

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>